import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function RunAgent() {

    return (
        <div>
            <DHeader>Running the Agent</DHeader>
       
            <DText>
              Now that the reasoner, instructions and tools have been passed to the Agent, the Agent can be used to perform the tasks it was designed for.
            
            </DText>
            <DText>
              To run the task, we use the run_agent method of the Laeyerz Agent.
              The task is passed to the Agent in the form of a Python dictionary.
            </DText>

            <DCode>
                {`task="""I am AV. Can you send me 2 packets milk, 
                noodles 1 packet, bread 1 packet, coffee 1 packet, apples 2"""
`}
            </DCode>
            
            <DCode>
                {`output = agent.run_agent(task=task, write_to_file=True)
`}
            </DCode>

            <DText>The 'write_to_file' parameter when set to 'True' writes out the Agent output to a json file.</DText>

              <br />

            <DText style={{fontWeight:'bold'}}>And, that's it. You have your Agent up and running. </DText>
       
            <DText>
             Agents in Laeyerz are like any other Node in the workflow. They can be added to a workflow like any other Node making them agentic.
            
            </DText>


        </div>
    )
}